import { ReferralProgramRebuild } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

/**
 * Release switch for the rebuilt referral programme (GOTU-6523 / GOTU-7435).
 *
 * The rebuild has no office-facing referral surface, so with the flag on the
 * legacy programme goes dark (route, "Enter Referral Link" menu, payout popup,
 * the v1 `?referral=` link) and signup posts `referredByCode` to referral-service
 * instead of `referralID` to the monolith. Every surface reads the flag through
 * this one hook so a session can never be half-legacy, half-rebuilt.
 *
 * `useFeatureFlag` is subscribed, so a mid-session flip moves the surfaces as
 * one. The signup form is the exception: it captures the value once at mount
 * (GOTU-7435) so a flip cannot change the path of a submission in progress.
 *
 * A rollout switch, not an experiment — hence the boolean `useFeatureFlag` and
 * not `useFeatureFlagVariant`. The business rules layered on top
 * (`useIsReferralDisabledForState`, parent office) still apply either way.
 */
export const useIsReferralRebuildEnabled = (): boolean => useFeatureFlag(ReferralProgramRebuild);
